import {
  RegistrationCodeEnabledResponse,
  RegistrationCompletedAuthenticatedResponse,
  RegistrationTokenDetailResponse
} from '../models/ApiResponse';

/**
 * Provides methods to register a user.
 */
export abstract class RegistrationService {
  /**
   * Initiates a new user registraion.
   *
   * @throws EmailAlreadyTakenException
   *
   * @param email The email address to send the verification mail to.
   * @param registrationCode The registration code entered by a user
   */
  abstract register(email: string, registrationCode?: string, captchaSolution?: string): Promise<void>;

  /**
   * Returns the details for a pending registration.
   *
   * @throws RegistrationNotFoundException
   * @throws TokenExpiredException
   *
   * @param registrationToken The registration token, obtained from the verification email.
   */
  abstract getRegistrationDetails(registrationToken: string): Promise<RegistrationTokenDetailResponse>;

  /**
   * Completes a users registration and authenticates at the same time
   * by returning the tokens required to access the software.
   *
   * @throws TokenExpiredException
   * @throws RegistrationNotFoundException
   *
   * @param registrationToken The registration token, obtained from the verification email.
   * @param password
   * @param firstName
   * @param lastName
   * @param title
   */
  abstract completeRegistrationAndAuthenticate(
    registrationToken: string,
    password: string,
    firstName: string,
    lastName: string,
    title: string
  ): Promise<RegistrationCompletedAuthenticatedResponse>;

  /**
   * Resends the verification email to a user which has already initiated a registration.
   *
   * @throws RegistrationNotFoundException
   *
   * @param email The email address of the users, which has been used in the registration.
   */
  abstract resendVerificationMail(email: string): Promise<void>;

  /**
   * Checks if the registraion code is enabled or not.
   */
  abstract registraionCodeEnabled(): Promise<RegistrationCodeEnabledResponse>;
}
